import $ from 'jquery';

$(document).on('gform_confirmation_loaded', function(event, formId) {

	window.dataLayer = window.dataLayer || [];
	dataLayer.push({
		'event': 'g_form_submit',
		'form_submission': 'valid'
	});

});

$('.quiz_start_page .gform_next_button').on('click', function (e) {

		var hcp_provider = $('input[name="input_1"]:checked').val();

		window.dataLayer = window.dataLayer || [];
		dataLayer.push({
			'event': 'start_energy_quiz',
			'quiz_type': hcp_provider
		});

	});

$(document).on('gform_page_loaded', function(event, form_id, current_page){
	$('.quiz_start_page .gform_next_button').on('click', function (e) {

		var hcp_provider = $('input[name="input_1"]:checked').val();

		window.dataLayer = window.dataLayer || [];
		dataLayer.push({
			'event': 'start_energy_quiz',
			'quiz_type': hcp_provider
		});

	});
});
